import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.63 2.598a1.5 1.5 0 0 1 .37.988l-.002.1a1.5 1.5 0 0 1-.437.961L8.364 6.844h-1.41A1.5 1.5 0 0 0 5.85 9.359l-.582.581-.085.08a1.91 1.91 0 0 1-2.22.227l-.609.607-.047.042a.5.5 0 0 1-.66-.749l.607-.608A1.9 1.9 0 0 1 2 8.586l.004-.116c.029-.467.227-.907.557-1.237l3.732-3.732-.792-.793-1.647 1.646-.047.041a.5.5 0 0 1-.66-.748l2-2 .047-.042a.5.5 0 0 1 .66.042l1.147 1.146.853-.853.072-.068a1.5 1.5 0 0 1 2.05.068l.585.585zM9.897 3.89a.5.5 0 0 0-.044-.658l-.585-.585-.05-.044a.5.5 0 0 0-.304-.103l-.066.005a.5.5 0 0 0-.288.142l-.853.853 1.293 1.293.853-.853z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7.086 8.398h2.952",
      style: {"stroke-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }